import { WebPortalService } from "../resource";

const MlhgModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    }
  },
  actions: {
    createData({ commit, state }, data) {
      return WebPortalService.MlhgCreate(data);
    },
    updateData({ commit, state }, data) {
      return WebPortalService.MlhgUpdate(data);
    },
    deleteData({ commit, state }, data) {
      return WebPortalService.MlhgDelete(data);
    },
    async listData({ commit, state }, data) {
      try {
        const res = await WebPortalService.MlhgList(data);
        if (res.data.Data == null) {
          commit("SET_DATA", []);
        } else {
          commit("SET_DATA", res.data.Data);
        }
      } catch (err) {
        commit("SET_DATA", []);
      }
    }
  },
  getters: {
    getData(state) {
      return state.data;
    },
    getMlhgMember(state){
      return state.data;
      //  return state.data.filter(item => item.)

    }
  }
};

export default MlhgModule;
